import "@/App.css";
import "./design-system";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import LandingPage from "./pages/LandingPage";
import FrozenV2Page from "./components/FrozenV2Page";
import AdminPage from "./pages/AdminPage";
import ForgotPasswordPage from "./pages/admin/ForgotPasswordPage";
import ResetPasswordPage from "./pages/admin/ResetPasswordPage";
import AboutPage from "./pages/legal/AboutPage";
import MissionPage from "./pages/legal/MissionPage";
import PartnerPage from "./pages/legal/PartnerPage";
import ForAuthorsPage from "./pages/legal/ForAuthorsPage";
import ContactPage from "./pages/legal/ContactPage";
import PrivacyPage from "./pages/legal/PrivacyPage";
import TermsPage from "./pages/legal/TermsPage";
import BlogIndexPage from "./pages/blog/BlogIndexPage";
import WhyIBuiltIcraftzPage from "./pages/blog/WhyIBuiltIcraftzPage";
import LoginPage from "./pages/auth/LoginPage";
import SignupPage from "./pages/auth/SignupPage";
import VerifyEmailPage from "./pages/auth/VerifyEmailPage";
import UserForgotPasswordPage from "./pages/auth/ForgotPasswordPage";
import UserResetPasswordPage from "./pages/auth/ResetPasswordPage";
import MyStoryPage from "./pages/MyStoryPage";
import PricingPage from "./pages/PricingPage";
import MyCraftzPage from "./pages/MyCraftzPage";
import MyCraftzIntroPage from "./pages/MyCraftzIntroPage";
import MyCraftzStagePage from "./pages/MyCraftzStagePage";
import JourneyPage from "./pages/JourneyPage";
import JourneyLibraryPage from "./pages/JourneyLibraryPage";
import BookDetailPage from "./pages/BookDetailPage";
import CollectionsPage from "./pages/CollectionsPage";
import MySanctuaryPage from "./pages/MySanctuaryPage";
import MyJourneyPage from "./pages/MyJourneyPage";
import AdminUserDetailPage from "./pages/admin/AdminUserDetailPage";
import AdminUserViewPage from "./pages/admin/AdminUserViewPage";
import DesignSystemPage from "./pages/DesignSystemPage";
import HomePage from "./pages/HomePage";
import HomeV3Page from "./pages/HomeV3Page";
import LibraryPage from "./pages/LibraryPage";
import BodhaPage from "./pages/BodhaPage";
import SankalpaPage from "./pages/SankalpaPage";
import SadhanaPage from "./pages/SadhanaPage";
import SiddhiPage from "./pages/SiddhiPage";
import BookInfographicPage from "./pages/BookInfographicPage";
import BookInfographicDiagramPreviewPage from "./pages/BookInfographicDiagramPreviewPage";
import "./styles/BookInfographicPage.css";
import { GlobalChrome } from "./components/GlobalChrome";

function App() {
  useEffect(() => {
    // ?colors=old → temporary preview of old palette
    const params = new URLSearchParams(window.location.search);
    if (params.get('colors') === 'old') {
      document.body.classList.add('colors-old');
    } else {
      document.body.classList.remove('colors-old');
    }
  }, []);

  return (
    <div className="App">
      <GlobalChrome />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomeV3Page />} />
            <Route path="/home-step2" element={<FrozenV2Page slug="homepage_step2" title="iCRAFTZ (Step-2 hybrid)" />} />
            <Route path="/home-v1" element={<FrozenV2Page slug="homepage" title="iCRAFTZ (v1 painted)" />} />
            <Route path="/home-v2" element={<HomePage />} />
            <Route path="/home-v3" element={<HomeV3Page />} />
            <Route path="/library"    element={<LibraryPage />} />
            <Route path="/library-v1" element={<FrozenV2Page slug="library"  title="iCRAFTZ — Library (v1 frozen)" />} />
            <Route path="/library-v3" element={<LibraryPage />} />
            <Route path="/bodha"        element={<BodhaPage />} />
            <Route path="/bodha-v2"     element={<BodhaPage />} />
            <Route path="/bodha-frozen" element={<FrozenV2Page slug="bodha" title="iCRAFTZ — Bodha (frozen mockup)" />} />
            <Route path="/sankalpa"        element={<SankalpaPage />} />
            <Route path="/sankalpa-v2"     element={<SankalpaPage />} />
            <Route path="/sankalpa-frozen" element={<FrozenV2Page slug="sankalpa" title="iCRAFTZ — Sankalpa (frozen mockup)" />} />
            <Route path="/sadhana"        element={<SadhanaPage />} />
            <Route path="/sadhana-v2"     element={<SadhanaPage />} />
            <Route path="/sadhana-frozen" element={<FrozenV2Page slug="sadhana"  title="iCRAFTZ — Sadhana (frozen mockup)" />} />
            <Route path="/siddhi"         element={<SiddhiPage />} />
            <Route path="/infographic"          element={<BookInfographicPage />} />
            <Route path="/infographic/:bookId"  element={<BookInfographicPage />} />
            <Route path="/infographic-diagram/:bookId" element={<BookInfographicDiagramPreviewPage />} />
            <Route path="/book/:id"    element={<BookDetailPage />} />
            <Route path="/collections" element={<CollectionsPage />} />
            <Route path="/my-sanctuary" element={<MySanctuaryPage />} />
            <Route path="/my-journey" element={<MyJourneyPage />} />
            <Route path="/design-system" element={<DesignSystemPage />} />
            <Route path="/v1" element={<LandingPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/admin/users/:userId" element={<AdminUserDetailPage />} />
            <Route path="/admin/users/:userId/view" element={<AdminUserViewPage />} />
            <Route path="/admin/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/admin/reset-password" element={<ResetPasswordPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route path="/forgot-password" element={<UserForgotPasswordPage />} />
            <Route path="/reset-password" element={<UserResetPasswordPage />} />
            <Route path="/my-story" element={<MyStoryPage />} />
            <Route path="/mycraftz" element={<MyCraftzPage />} />
            <Route path="/mycraftz/intro" element={<MyCraftzIntroPage />} />
            <Route path="/mycraftz/stage/:stage" element={<MyCraftzStagePage />} />
            <Route path="/mycraftz/journey/:slug" element={<JourneyPage />} />
            <Route path="/journeys/:slug" element={<JourneyLibraryPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/mission" element={<MissionPage />} />
            <Route path="/partner" element={<PartnerPage />} />
            <Route path="/for-authors" element={<ForAuthorsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/blogs" element={<BlogIndexPage />} />
            <Route path="/blogs/why-i-built-icraftz" element={<WhyIBuiltIcraftzPage />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
